import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';

@Component({
  selector: 'moh-survivors',
  templateUrl: './survivors.component.html',
  styleUrls: ['./survivors.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SurvivorsComponent implements OnInit {
  
  constructor() {
  }

  ngOnInit(): void { }
    

}



// WEBPACK FOOTER //
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/components/survivors/survivors/survivors.component.ts